import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";
import { getRibbonBottomBarStylingConstants } from "../../ribbonStylingConstants";

export interface RibbonControlGroupClassNames {
  root: string;
  container: string;
  groupLabel: string;
  groupLabelContainer: string;
  layoutWrapper: string;
}

export const layoutWrapperTransitionClassNames = {
  enter: "controlGroupLayout-enter",
  enterActive: "controlGroupLayout-enter-active",
  exit: "controlGroupLayout-exit",
  exitActive: "controlGroupLayout-exit-active",
};

const layoutScaleTransitionDuration = 300;
const layoutOpactiyTransitionDuration = 87;
export const layoutTransitionExitDuration = layoutOpactiyTransitionDuration;
export const layoutTransitionEnterDuration =
  layoutOpactiyTransitionDuration + layoutScaleTransitionDuration;

export const getRibbonControlGroupMLRClassNames = memoizeFunction(
  (
    enterInitialWidth: number | undefined,
    finalWidth: number | undefined,
    hideGroupLabel: boolean | undefined
  ): RibbonControlGroupClassNames => {
    return mergeStyleSets({
      root: {
        display: "inline-block",
        verticalAlign: "top",
        selectors: {
          [`.controlGroupLayout-enter & .layoutWrapper .moved`]: {
            opacity: 0,
          },
          [`.controlGroupLayout-enter:not(.controlGroupLayout-enter-active) & .layoutWrapper`]:
            {
              width:
                enterInitialWidth != null
                  ? `${enterInitialWidth}px !important`
                  : undefined,
            },
          [`.controlGroupLayout-enter-active & .layoutWrapper`]: {
            transition: `width ${layoutScaleTransitionDuration}ms  cubic-bezier(0.1, 0.9, 0.2, 1)`,
            width: finalWidth != null ? `${finalWidth}px` : undefined,
            opacity: 1,
          },
          [`.controlGroupLayout-enter-active & .layoutWrapper .moved`]: {
            transition: `opacity ${layoutOpactiyTransitionDuration}ms linear ${layoutScaleTransitionDuration}ms`,
            opacity: 1,
          },
          [`.controlGroupLayout-exit & .layoutWrapper .moved`]: {
            opacity: 1,
          },
          [`.controlGroupLayout-exit-active & .layoutWrapper .moved`]: {
            transition: `opacity ${layoutOpactiyTransitionDuration}ms linear`,
            opacity: 0,
          },
        },
      },
      container: {
        display: "flex",
        height: getRibbonBottomBarStylingConstants("Multiline").bottomBarHeight,
        flexDirection: "column",
      },
      groupLabel: {
        flexGrow: 1,
        textAlign: "center",
        userSelect: "none",
        fontSize: 10,
        lineHeight: 10,
      },
      groupLabelContainer: {
        display: "flex",
        height: 12,
        justifyContent: hideGroupLabel ? "flex-end" : undefined,
      },
      layoutWrapper: {
        flex: 1,
        display: "inline",
      },
    });
  }
);
